export type ModalsTransactionsType =
  | 'details'
  | 'resendReceipt'
  | 'editNote'
  | 'cancel'
  | 'addChargeback'
  | 'viewRefundReason';

export enum PaymentTypeEnum {
  'card' = 1,
  'payPal' = 2,
  'check' = 3,
  'cash' = 4,
  'upi' = 5,
  'netBanking' = 6,
}
